import { render, staticRenderFns } from "./GuardOverlay.vue?vue&type=template&id=54ed1b90&scoped=true"
import script from "./GuardOverlay.vue?vue&type=script&lang=js"
export * from "./GuardOverlay.vue?vue&type=script&lang=js"
import style0 from "./GuardOverlay.vue?vue&type=style&index=0&id=54ed1b90&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ed1b90",
  null
  
)

export default component.exports